import React from "react";
import styles from "./LoadingState.module.css";
import dinoGif from "../img/dinoGif.gif";

export function LoadingState({
  message = "Cargando...",
  fullscreen = false,
  minHeight = 260,
}) {
  const className = fullscreen ? styles.fullscreen : styles.inline;

  return (
    <div className={className} style={!fullscreen ? { minHeight } : undefined}>
      <div className={styles.content}>
        <img
          src={dinoGif}
          alt=""
          className={styles.gif}
          width={110}
          height={110}
          loading="eager"
          draggable={false}
        />
        {message ? <div className={styles.message}>{message}</div> : null}
      </div>
    </div>
  );
}
